<template>
  <v-col cols="6">
    <v-card class="align-start metrics-card-middle-bottom">
      <v-card-title class="d-flex justify-center font-weight-bold text-decoration-underline">
        Agent Performance
      </v-card-title>
      <v-card-text class="d-flex flex-row justify-space-around align-center metrics-card-text">
        <StatsValue :loading="loading" title="Agents requested" :subtitle="agentsRequestedPercentage">
          {{agentsRequested}}
        </StatsValue>
        <StatsValue :loading="loading" title="Chats joined" :subtitle="chatsJoinedPercentage">
          {{chatsJoined}}
        </StatsValue>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import {LoadingState} from "@/store/constants";
import StatsValue from "@/components/HealthScore/StatsValue.vue";
import {createPercentageSubtitle} from "@/components/HealthScore/healthScoreHelpers";

export default {
  name: 'AgentPerformance',
  components: {StatsValue},
  computed: {
    ...mapState('healthScoreStore', ['chatOverview']),
    ...mapGetters('healthScoreStore', ['engagements']),
    loading() {
      return this.chatOverview.state === LoadingState.LOADING;
    },
    agentsRequested() {
      const humanRequested = this.chatOverview.data.find((element) => element.EVENT_NAME === 'human_requested');
      return humanRequested ? humanRequested.RESULT : 0;
    },
    agentsRequestedPercentage() {
      return createPercentageSubtitle(this.agentsRequested, this.engagements, 'Engagements');
    },
    chatsJoined() {
      const events = this.chatOverview.data.find((element) => element.EVENT_NAME === 'human_answered');
      return events ? events.RESULT : 0;
    },
    chatsJoinedPercentage() {
      return createPercentageSubtitle(this.chatsJoined, this.agentsRequested, 'Requested');
    },
  }
}
</script>
